import { type StateType } from '../../states';
import {
  MyMatchBetStatus,
  MyMatchBetStatuses,
  MyMatchFutureEntitiesFullOutcomeState,
  type MyMatchState,
} from '../../states/mymatch';
import { type MyMatchFutureEntities } from '../../states/mymatch';
import { type MyMatchFutureEntitiesOutcomes } from '../../states/mymatch';
import { type MyMatchFutureEntitiesBets } from '../../states/mymatch';
import { type MyMatchFutureEntitiesBetState } from '../../states/mymatch';
import { type MyMatchFutureEntitiesOutcomeState } from '../../states/mymatch';
import { type Selector } from '../../types/selectors';
import { getBetIdFromProps, getOutcomeIdOrOddsIdFromProps } from '../_propsGetters_';
import { type GetOutcomeIdOrOddsIdFromPropsType } from '../_propsGetters_';

const emptyObj = {};
const emptyArr: [] = [];

export const selectMyMatchState: Selector<MyMatchState> = (state: StateType) => state.mymatch ?? emptyObj;

//#region state.mymatch
export const selectMyMatchGetFutureOddsIsLoadingMatchIds: Selector<Array<number>> = (state: StateType) =>
  selectMyMatchState(state).getFutureOddsIsLoadingMatchIds ?? emptyArr;

export const selectMyMatchModeMatchIds: Selector<Array<number>> = (state: StateType) =>
  selectMyMatchState(state).myMatchModeMatchIds ?? emptyArr;

export const selectMyMatchFutureEntities: Selector<MyMatchFutureEntities> = (state: StateType) =>
  selectMyMatchState(state).futureEntities ?? emptyObj;
//#endregion

//#region state.mymatch.futureEntities
export const selectMyMatchFutureEntitiesOutcomes: Selector<MyMatchFutureEntitiesOutcomes> = (state: StateType) =>
  selectMyMatchFutureEntities(state).outcomes ?? emptyObj;

export const selectMyMatchFutureEntitiesBets: Selector<MyMatchFutureEntitiesBets> = (state: StateType) =>
  selectMyMatchFutureEntities(state).bets ?? emptyObj;
//#endregion

//#region state.mymatch.futureEntities.bets
type MyMatchFutureEntitiesBetsSelectorProps = {
  betId?: number;
};

export const selectMyMatchFutureEntitiesBetsEntity: Selector<MyMatchFutureEntitiesBetState | undefined> = (
  state: StateType,
  props: MyMatchFutureEntitiesBetsSelectorProps = {},
) => {
  const futureBets = selectMyMatchFutureEntitiesBets(state);
  const betId = getBetIdFromProps(state, props);

  if (betId) {
    return futureBets[betId];
  }
};
//#endregion

//#region state.mymatch.futureEntities.bets[betId]
export const selectMyMatchFutureEntitiesBetsEntityMmStatus: Selector<MyMatchBetStatus | undefined> = (
  state: StateType,
  props: MyMatchFutureEntitiesBetsSelectorProps = {},
) => selectMyMatchFutureEntitiesBetsEntity(state, props)?.mmStatus ?? MyMatchBetStatuses.INACTIVE;

export const selectMyMatchFutureEntitiesBetsEntityMmMultichoiceStatus: Selector<MyMatchBetStatus | undefined> = (
  state: StateType,
  props: MyMatchFutureEntitiesBetsSelectorProps = {},
) => selectMyMatchFutureEntitiesBetsEntity(state, props)?.mmMultichoiceStatus ?? MyMatchBetStatuses.INACTIVE;
//#endregion

//#region state.mymatch.futureEntities.outcomes
export const selectMyMatchFutureEntitiesOutcomesEntity: Selector<MyMatchFutureEntitiesFullOutcomeState | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => {
  const futureOutcomes = selectMyMatchFutureEntitiesOutcomes(state);
  const outcomeId = getOutcomeIdOrOddsIdFromProps(state, props);

  if (outcomeId) {
    return futureOutcomes[outcomeId];
  }
};

//#region state.mymatch.futureEntities.outcomes[outcomeId]
export const selectMyMatchFutureEntitiesOutcomesEntityMmOdds: Selector<number | null | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectMyMatchFutureEntitiesOutcomesEntity(state, props)?.mmOdds;

export const selectMyMatchFutureEntitiesOutcomesEntityMmContradicting: Selector<boolean> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectMyMatchFutureEntitiesOutcomesEntity(state, props)?.mmContradicting ?? false;

export const selectMyMatchFutureEntitiesOutcomesEntityMultichoice: Selector<
  MyMatchFutureEntitiesOutcomeState | undefined
> = (state: StateType, props: GetOutcomeIdOrOddsIdFromPropsType = {}) =>
  selectMyMatchFutureEntitiesOutcomesEntity(state, props)?.multichoice;

export const selectMyMatchFutureEntitiesOutcomesEntityMultichoiceMmOdds: Selector<number | null | undefined> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectMyMatchFutureEntitiesOutcomesEntityMultichoice(state, props)?.mmOdds;

export const selectMyMatchFutureEntitiesOutcomesEntityMultichoiceMmContradicting: Selector<boolean> = (
  state: StateType,
  props: GetOutcomeIdOrOddsIdFromPropsType = {},
) => selectMyMatchFutureEntitiesOutcomesEntityMultichoice(state, props)?.mmContradicting ?? false;
//#endregion
